import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { date } from "../../shared/src/codecs/types/date";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { currencyInteger } from "../../shared/src/codecs/types/currencyInteger";
import { union } from "../../shared/src/codecs/types/union";

// The case facts an email template is allowed to merge in. Deliberately a flat set of
// already-formatted strings rather than nested domain objects: a template author picks a
// token from a list, and every token has exactly one resolver, so there is no place for a
// template to reach into the domain and format something a different way.
//
// Empty string means "we do not hold this". Resolvers decide what that does to the
// surrounding sentence - see app/domain/emailTemplates/tokens.ts.
export const EmailTemplateContext = required({
    client_names: string(),
    property_address: string(),
    title_numbers: string(),
    klyant_matter_id: string(),
    case_handler_name: string(),
    expected_completion_date: union([date(), nullCodec()]),
    // The lender on the EXISTING charge, taken from the title register, so free text and
    // not one of the cases_lender_names_on_panel values. This is the lender a redemption
    // statement is requested from on a sale.
    charge_beneficiary: string(),
    charge_account_number: string(),
    // The purchase/remortgage lender, which IS the enum, and therefore the only lender we
    // can attach a panel number to - we are on their panel because we act for them. It is
    // not the same lender as charge_beneficiary above.
    mortgage_lender_name: string(),
    mortgage_lender_panel_number: string(),
    mortgage_offer_date: union([date(), nullCodec()]),
    price_pence: union([currencyInteger(), nullCodec()]),
});
export type TEmailTemplateContextCodec = typeof EmailTemplateContext;
export type TEmailTemplateContext = TTypeOfCodec<TEmailTemplateContextCodec>;
